import configureStore from "src/store/configureStore";

const store = configureStore();  

export default store;
